import React, { useState, useEffect } from "react";

//Redux
import { useDispatch, useSelector } from "react-redux";
import { subirBoletas } from "../../../actions/boletasActions";
import { avisoError } from "../../components/AvisosMensajes/MensajesSwalf";
import DropZoneV2 from "../../components/plugins/DropzoneV2";
import SelectVariable from "../../components/SelectVariable/SelectVariable";
import { Alert } from "react-bootstrap";

const style = {
  boton: {
    background: "#28314A",
    color: "#fff",
  },
  buttonText: {
    fontSize: "13px",
    background: "#28314A",
    color: "#fff",
  },
  textArchivo: {
    fontSize: "12px",
    fontWeight: "600",
    color: "#aaa",
  },
};

const meses = [
  {
    id: 1,
    value: "Enero",
  },
  {
    id: 2,
    value: "Febrero",
  },
  {
    id: 3,
    value: "Marzo",
  },
  {
    id: 4,
    value: "Abril",
  },
  {
    id: 5,
    value: "Mayo",
  },
  {
    id: 6,
    value: "Junio",
  },
  {
    id: 7,
    value: "Julio",
  },
  {
    id: 8,
    value: "Agosto",
  },
  {
    id: 9,
    value: "Septiembre",
  },
  {
    id: 10,
    value: "Octubre",
  },
  {
    id: 11,
    value: "Noviembre",
  },
  {
    id: 12,
    value: "Diciembre",
  },
];

const anios = [
  {
    id: "2019",
    value: "2019",
  },
  {
    id: "2020",
    value: "2020",
  },
  {
    id: "2021",
    value: "2021",
  },
  {
    id: "2022",
    value: "2022",
  },
  {
    id: "2023",
    value: "2023",
  },
  {
    id: "2024",
    value: "2024",
  },
  {
    id: "2025",
    value: "2025",
  },
  {
    id: "2026",
    value: "2026",
  },
  {
    id: "2027",
    value: "2027",
  },
];

const FormularioSubidaBoletas = () => {
  const dt = new Date();
  const [isValidNombre, setisValidNombre] = useState(true);
  const { usuario } = useSelector((state) => state.usuario);
  const [periodoBoletas, setPeriodoBoletas] = useState({
    periodo: dt.getFullYear(),
    mes: dt.getMonth() + 1,
  });
  const [archivos, setArchivos] = useState([]);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setPeriodoBoletas({
      ...periodoBoletas,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (archivos.length > 0) {
      dispatch(subirBoletas(periodoBoletas, archivos, usuario));
    } else {
      avisoError("Debe cargar algun documento primero...");
    }
  };

  const deleteItem = (itemName) => {
    const filtredData = archivos.filter((item) => item.name !== itemName);
    setArchivos(filtredData);
  };

  return (
    <form
      id="formNuevo2"
      className="px-md-5 py-3"
      onSubmit={(e) => handleSubmit(e, this)}
    >
      <div className="form-row align-items-center mb-3">
        <div className="col-md-3">
          <label htmlFor="titulopop" className="mb-0">
            Periodo:
          </label>
        </div>
        <div className="col-md-7">
          <SelectVariable
            name="periodo"
            datos={anios}
            value={periodoBoletas.periodo}
            primerSelect="Seleccione un periodo"
            handleChange={handleChange}
            isRequired={true}
          />
        </div>
        <div className="col-md-2"></div>
      </div>
      <div className="form-row align-items-center mb-3">
        <div className="col-md-3">
          <label htmlFor="enlace" className="mb-0">
            Mes:
          </label>
        </div>
        <div className="col-md-7">
          <SelectVariable
            name="mes"
            datos={meses}
            value={periodoBoletas.mes}
            primerSelect="Seleccione un mes"
            handleChange={handleChange}
            isRequired={true}
          />
        </div>
        <div className="col-md-2"></div>
      </div>
      <div className="form-group">
        <DropZoneV2 
        getArchivos={setArchivos}
        setisValidNombre={setisValidNombre}/>
        {archivos.length > 0 ? (
          <div className="row">
            <div className="col-12 p-1">N° Archivos: {archivos.length} </div>
            <div className="col-12 p-1 mb-2">
              Lista de Archivos:
              {archivos.map((archivo, i) =>
                archivo ? (
                  <div className="row p-2" key={i}>
                    <div className="col-10">{archivo.name}</div>{" "}
                    <div className="col-2">
                      {" "}
                      <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={() => deleteItem(archivo.name)}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                ) : null
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      {!isValidNombre &&
      <Alert variant="danger">
        El formato para los archivos debe ser el siguiente: DNI_EMPLEADO_EMPRESA.pdf
      </Alert>
      }
      <button type="submit" className="btn" style={style.boton}>
        <i className="fa fa-floppy-o"></i> Guardar
      </button>
    </form>
  );
};

export default FormularioSubidaBoletas;
